import { BrowserSessionApiClient } from "./browserSessionApiClient";

export type SmsSettings = {
  companyName: string;
  phone: string;
  phoneVerified: boolean;
  taskEnabled: boolean;
  quotationEnabled: boolean;
  canManageOwner: boolean;
  quotationOwnerEmail: string;
  provider: string;
  eventsEnabled: boolean;
};
const base = (import.meta.env.VITE_API_BASE_URL || "/api").replace(/\/+$/, "");
const client = new BrowserSessionApiClient(base);
export async function smsSettingsRequest(body?: Record<string, unknown>): Promise<SmsSettings> {
  const response = await client.request<{ data: SmsSettings }>(`${base}/v1/sms/settings`, {
    method: body ? "PUT" : "GET",
    ...(body ? { body } : {}),
  });
  return response.data;
}
